import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
const areas = [{
  title: 'Knowledge systems',
  body: 'Semantic relationships, source-grounded retrieval, curation and review.',
  href: '/semantic-knowledge',
  linkLabel: 'Semantic Knowledge Platform'
}, {
  title: 'Human capability',
  body: 'The Human Capability Framework, CJI, NCJI and the five pillars.',
  href: '/human-capability',
  linkLabel: 'Human Capability Framework'
}, {
  title: 'Studies and validation',
  body: 'Current research priorities and planned pilots, each labeled by status.',
  href: '#research-priorities',
  linkLabel: 'Research priorities'
}, {
  title: 'Publications',
  body: 'Publication plans, kept distinct from completed publications. None are published yet.',
  href: '/roadmap#publications',
  linkLabel: 'Publication plans'
}, {
  title: 'Future research',
  body: 'Exploratory research concepts, including civic ranking, universal leadership certification and emotion inference.',
  href: '#research-concepts',
  linkLabel: 'Research concepts'
}, {
  title: 'Roadmap',
  body: 'Current demos, development priorities and research milestones.',
  href: '/roadmap',
  linkLabel: 'Roadmap'
}];

/** Overview of how the research program is organized. */
export function ResearchMap() {
  return <section aria-labelledby="research-map-title" className="bg-surface-bg border-b border-line py-16 lg:py-20" data-id="element-1865" data-mp="3iwarpa20mmya">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1866" data-mp="3duv7tlbkqmhh">
        <motion.h2 {...fadeUp} id="research-map-title" className="font-heading font-bold text-3xl text-ink-dark tracking-tight mb-8" data-id="element-1867" data-mp="3rp602cms4ysa">
          How our research is organized
        </motion.h2>
        <motion.ol {...fadeUp} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1868" data-mp="2z70dk0hx4a2a">
          {areas.map((area, index) => <li key={area.title} className="flex flex-col bg-white p-6" data-id="element-1869" data-mp="y4ssdwka39zl" data-mpi={index}>
              <span className="text-sm font-medium text-teal" aria-hidden="true" data-id="element-1870" data-mp="134neznx0tdeu">{index + 1}</span>
              <h3 className="mt-2 font-heading font-bold text-lg text-ink-dark" data-id="element-1871" data-mp="17vx2oiz0e6o3">{area.title}</h3>
              <p className="mt-2 mb-5 text-ink-muted leading-relaxed" data-id="element-1872" data-mp="1cugsiugq42lq">{area.body}</p>
              <a href={area.href} className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1873" data-mp="f6zoaqxx4u0m">
                {area.linkLabel} <ArrowRight size={14} aria-hidden="true" data-id="element-1874" data-mp="p4cmkgg2bqrk" />
              </a>
            </li>)}
        </motion.ol>
      </div>
    </section>;
}